/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react';
import { Typography, Card } from '@mui/material';
import BackButton from '../BackButton';
import DMSAdvantageImage from "../../../../../../assets/images/ArticleImages/DMS-Advantage-in-Preventing-Driver-Fatigue-and-Distraction-1.webp";
import DriverMonitoringSystem from "../../../../../../assets/images/ArticleImages/What-is-a-Driver-Monitoring-System.webp";
import HowDriverMonitoringSystem from "../../../../../../assets/images/ArticleImages/How-Does-a-Driver-Monitoring-System-Work.webp";
import KeyAdvantages from "../../../../../../assets/images/ArticleImages/Key-Advantages.webp";
import HowDriverMonitoring from "../../../../../../assets/images/ArticleImages/How-Driver-Monitoring-Systems-Advantages-Fleet-Managers.webp";
import NovusHitechDriver from "../../../../../../assets/images/ArticleImages/Novus-Hi-Techs-Driver-Monitoring-System-Solutions.webp";
import WhyChooseNovus from "../../../../../../assets/images/ArticleImages/7.webp";

// Define a type for the content blocks
type ContentBlock =
  | { type: 'heading'; value: string; variant?: 'h4' | 'h5' | 'h6' | 'subtitle2'; style?: React.CSSProperties }
  | { type: 'paragraph'; value: string; style?: React.CSSProperties }
  | { type: 'image'; src: string; alt?: string; style?: React.CSSProperties };

const DMSAdvantage: React.FC = () => {
  // Page header information
  const title = "DMS Advantage in Preventing Driver Fatigue and Distraction";
  const headerImageSrc = DMSAdvantageImage;

  // Define the content of your article as a list of blocks.
  const contentBlocks: ContentBlock[] = [
    {
      type: 'paragraph',
      value: "It has been observed that driver fatigue and less attentiveness leads to major road accidents and is said that these two are the major common factors that lead to thousands of road accidents globally. With upliftment in technology and artificial intelligence in vehicles adaptability of DMS (driver monitoring system) has emerged and came out as a great strategy to improve and better road safety, decrease maintenance costs with emphasis on safe and secure driving techniques. These DMS advantages of advanced technologies are shifting the perception of fleet managers, logistics firms, and even individual drivers on how to deal with current challenges on the road.",
    },
    {
        type: 'paragraph',
        value: "In this blog, we will read and learn how DMS yields benefits, its implementation in fleet management, and also elaborate why Novus Hi-Tech is a one stop solution to choose as a solution for DMS system.",
      },
    {
      type: 'heading',
      value: "What is a Driver Monitoring System?",
      variant: 'h6',
      style: { marginTop: '16px', marginBottom: '8px' },
    },
    {
        type: 'image',
        src: DriverMonitoringSystem,
        alt: "Connected vehicles schematic",
        style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
      },
    {
        type: 'paragraph',
        value: "DMS stands for driver monitoring system, a recent technology that helps in the tracking and inspecting a driver’s activities and sleeping patterns during driving in view of monitored surveillance. The smart sensors, cameras, and AI that is the most used word in today’s era are used in DMS technology, enabling it to understand and analyze the drivers at all times so that any signs of drowsiness, loss of focus, or unsafe driving may be detected.",
      },
      {
        type: 'paragraph',
        value: "This system not only overcomes accidental situations before they happen but also enhances the overall performance of the vehicle and ensures the driver remains vigilant and responsive hence DMS advantages in various aspects making it the most important addition in smart mobility.",
      },
      {
        type: 'heading',
        value: "How Does a Driver Monitoring System Work?",
        variant: 'h6',
        style: { marginTop: '16px', marginBottom: '8px' },
      },
      {
        type: 'image',
        src: HowDriverMonitoringSystem,
        alt: "Connected vehicles schematic",
        style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
      },
      {
        type: 'paragraph',
        value: "DMS uses a combination of technologies to provide real-time data regarding a driver’s state:",
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Cameras:</strong> Both infrared and optical cameras continuously track facial expressions and the directions of one’s pupils.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> AI Algorithms:</strong> These algorithms analyze patterns of driving behavior, identifying anomalies that could indicate fatigue or distraction.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Real-Time Alerts:</strong> The system gives audio-visual or haptic alerts to notify the driver in real-time when dangerous behavior is detected.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Data Integration:</strong> DMS integrates with fleet management systems to generate in-depth reports on driver performance, thereby improving decision-making and accountability.
          </>
        ) as unknown as string,
      },
      {
        type: 'heading',
        value: "Key Advantages of Driver Monitoring Systems",
        variant: 'h6',
        style: { marginTop: '16px', marginBottom: '8px' },
      },
      {
        type: 'image',
        src: KeyAdvantages,
        alt: "Connected vehicles schematic",
        style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
      },
      {
        type: 'paragraph',
        value: (
          <>
           Principals of<strong> DMS advantages:</strong>
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            1.<strong> Improves Road Safety:</strong> DMS performs analysis for drowsiness, distraction and dangerous driving behavior, and sends timely alerts to avoid accidents. This capability substantially decreases the probability of collisions due to human error.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            2.<strong> Prevents Unauthorized Vehicle Use:</strong> Theft or misuse is diminished by enabling vehicles to only be driven by authorized persons with the DMS.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            3.<strong> Decreases Costs:</strong> Due to fewer accidents, fleet operators incur lesser repair and underwriting costs. Moreover, preventing unauthorized use leverages operating costs.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            4.<strong> Improves Driver Performance:</strong> Drivers gain desirable habits and become more responsible through real-time feedback given to them.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            5.<strong> Improves Responsibility:</strong> Drivers are monitored by DMS enforcing company policy through driver behavioral analysis.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            6.<strong> Improves Fleet Operations:</strong> Fleet managers are able to increase the efficiency of fleet operations by automating routes and schedules based on driver activity and performance.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            7.<strong> Enables Predictive Maintenance:</strong> DMS can offer predictive maintenance and lessen downtime by knowing deterioration due to driver behavior and modification in vehicle functions.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            8.<strong> Aids in Smooth Scalability:</strong> DMS is a solution that works for any type and size of business as it can get an operation done more flexibly and efficiently.
          </>
        ) as unknown as string,
      },
      {
        type: 'heading',
        value: "How Driver Monitoring Systems Advantages Fleet Managers?",
        variant: 'h6',
        style: { marginTop: '16px', marginBottom: '8px' },
      },
      {
        type: 'image',
        src: HowDriverMonitoring,
        alt: "Connected vehicles schematic",
        style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
      },
      {
        type: 'paragraph',
        value: "Fleet managers are now tasked with achieving safety, compliance and efficiency with scale deployment of vehicles.",
      },
      {
        type: 'paragraph',
        value: "With the help of the below DMS advantages, they can achieve the following:",
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Real-Time Insights:</strong> Quick response to emerging needs through direct access and additional information on driver behavior.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Lower Downtime:</strong> Predictive maintenance measures ensure that cars are operational and do not incur unexpected breakdowns.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Regulatory Compliance:</strong> DMS enables fleets and logistics companies to control and report driver behavior in order to comply with diverse local and international regulations.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Cost Savings:</strong> Insurance costs and other expenses related to accidents are among the costs that the customer can experience.
          </>
        ) as unknown as string,
      },
      {
        type: 'heading',
        value: "Novus Hi-Tech’s Driver Monitoring System Solutions",
        variant: 'h6',
        style: { marginTop: '16px', marginBottom: '8px' },
      },
      {
        type: 'image',
        src: NovusHitechDriver,
        alt: "Connected vehicles schematic",
        style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
      },
      {
        type: 'paragraph',
        value: (
          <>
            <strong>Novus Hi-Tech</strong> is the leader in innovation, providing cutting-edge DMS advantages & technology to serve the varied requirements of contemporary fleets. Our offerings are:
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> AI-Driven Analytics:</strong> Employ AI capabilities in effectively analyzing driving behavior and providing targeted insights.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Real-Time Alerts:</strong> Receive alerts regarding issues such as distraction or sleepiness instantly, enabling an effective remedy.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Seamless Integration:</strong> Address the challenges of fleet management as our DMS integrates perfectly with the existing fleet management systems.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> User-Friendly Interface:</strong> Fleet controllers efficiently control and keep track of their fleet actively with easy-to-use dashboards and accessible controls.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            These<strong> DMS Advantages</strong> not only help for a safer environment but also saves many lives.
          </>
        ) as unknown as string,
      },
      {
        type: 'heading',
        value: "Why Choose Novus Hi-Tech for Your Driver Monitoring Needs?",
        variant: 'h6',
        style: { marginTop: '16px', marginBottom: '8px' },
      },
      {
        type: 'image',
        src: WhyChooseNovus,
        alt: "Connected vehicles schematic",
        style: { margin: '24px 0', width: '100%', height: 'auto', borderRadius: 12 },
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> AI-Powered Analytics:</strong> With the help of AI we can interpret driving behavior and provide/offer actionable insights.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Real-Time Alerts:</strong> We can attain real-time alerts to react and overcome situations like drowsiness or distraction.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> Seamless Integration:</strong> Our DMS seamlessly integrates with current fleet management systems for smooth operations.
          </>
        ) as unknown as string,
      },
      {
        type: 'paragraph',
        value: (
          <>
            •<strong> User-Friendly Interface:</strong> Simple-to-use dashboards and controls enable fleet managers to easily track and control their fleets.
          </>
        ) as unknown as string,
      },
      {
        type: 'heading',
        value: "Conclusion",
        variant: 'h6',
        style: { marginTop: '16px', marginBottom: '8px' },
      },
      {
        type: 'paragraph',
        value: "The advantage of DMS in preventing driver fatigue and distraction cannot be overstated. From enhancing road safety to maximizing fleet performance, this technology is revolutionizing the transport industry. With Novus Hi-Tech’s innovative solutions, fleet operators can deliver utmost safety, efficiency, and cost-effectiveness.",
      },
      {
        type: 'paragraph',
        value: (
          <>
            Take the first step towards a safer and smarter fleet today.<strong>  Contact Novus Hi-Tech to learn more about our advanced Driver Monitoring System solutions!</strong>
          </>
        ) as unknown as string,
      },
  ];

  // Function to render each content block based on its type.
  const renderContentBlock = (block: ContentBlock, index: number) => {
    switch (block.type) {
      case 'heading':
        return (
          <Typography
            key={index}
            variant={block.variant || 'h4'}
            style={{ fontWeight: 600, ...block.style }}
          >
            {block.value}
          </Typography>
        );
      case 'paragraph':
        return (
          <Typography
            key={index}
            variant="body1"
            style={{
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
              // color: 'gray',
              ...block.style,
            }}
          >
            {block.value}
          </Typography>
        );
      case 'image':
        return (
          <Card
            key={index}
            style={{
              overflow: 'hidden',
              borderRadius: 12,
              ...block.style,
            }}
          >
            <img
              src={block.src}
              alt={block.alt || 'Article image'}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Card>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col w-full">
      <BackButton />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'center' }}>
        {/* Header Section */}
        <div
          style={{
            width: '100%',
            maxWidth: '766px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          {/* Title & Tag Section */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Typography variant="h4" style={{ fontWeight: 600 }}>
              {title}
            </Typography>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >
            </div>
          </div>

          {/* Header Image */}
          <Card
            style={{
              width: '100%',
              height: 384,
              borderRadius: 12,
              overflow: 'hidden',
            }}
          >
            <img
              src={headerImageSrc}
              alt="Article header image"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Card>
        </div>

        {/* Content Section */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            maxWidth: '766px',
            padding: '16px 0',
          }}
        >
          {contentBlocks.map((block, index) => renderContentBlock(block, index))}
        </div>
      </div>
    </div>
  );
};

export default DMSAdvantage;
